/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · German (de) string table · skin-concerns.html
   English is the source of truth in the HTML; this file supplies the
   German counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-de.js.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.de = window.TD_I18N.de || {};
  Object.assign(window.TD_I18N.de, {

    /* ── Page header ── */
    'concerns.headLabel': 'Finde deine Formel',
    'concerns.headTitle': 'Beginne mit dem,<br><em>was dich stört.</em>',
    'concerns.headSub': 'Fünf Seren, fünf biologische Ziele. Beginne mit dem Anliegen, das dir am wichtigsten ist, und das richtige Serum wählt sich fast immer von selbst.',

    /* ── Jump bar ── */
    'concerns.jumpLabel': 'Springe zu',
    'concerns.jumpFirmness': 'Festigkeit',
    'concerns.jumpBrightness': 'Strahlkraft',
    'concerns.jumpHydration': 'Feuchtigkeit',
    'concerns.jumpFineLines': 'Feine Linien',
    'concerns.jumpDarkSpots': 'Dunkle Flecken',
    'concerns.jumpTexture': 'Textur',
    'concerns.jumpAcneScars': 'Aknenarben',
    'concerns.jumpDullness': 'Fahler Teint',

    /* ── Reusable row labels ── */
    'concerns.startWith': 'Beginne mit',
    'concerns.shopRoutine': 'Diese Routine kaufen →',
    'concerns.nameC': 'Serum C — <em>Strahlkraft</em>',
    'concerns.nameA': 'Serum A — <em>Erneuerung</em>',
    'concerns.nameO': 'Serum O — <em>Zellulär</em>',
    'concerns.nameM': 'Serum M — <em>Feuchtigkeit</em>',
    'concerns.nameR': 'Serum R — <em>Klarheit</em>',
    'concerns.rolePrimaryDay': 'Hauptrolle · Tag',
    'concerns.rolePrimaryNight': 'Hauptrolle · Nacht',
    'concerns.rolePrimaryDayNight': 'Hauptrolle · Tag + Nacht',
    'concerns.roleLayerDay': 'Schicht · Tag',
    'concerns.roleLayerNight': 'Schicht · Nacht',

    /* ── Concern 01 · Firmness ── */
    'concerns.c1Num': 'Anliegen 01',
    'concerns.c1Title': 'Festigkeit<br><em>& Elastizität.</em>',
    'concerns.c1Lede': 'Die Kieferlinie wird weicher. Die Wangenknochen verlieren ihren Halt. Die Haut beginnt zu sinken, statt sich zu halten. Das ist das erste sichtbare Zeichen dafür, dass die Kollagen- und Elastinproduktion verlangsamt ist, und das am einfachsten umzukehrende auf zellulärer Ebene.',

    /* ── Concern 02 · Brightness ── */
    'concerns.c2Num': 'Anliegen 02',
    'concerns.c2Title': 'Strahlkraft<br><em>& Sonnenschäden.</em>',
    'concerns.c2Lede': 'Die Haut wirkt fahl, auch wenn du es nicht bist. Oft ist es kumulativ: UV, Umweltverschmutzung, Stress, reduzierte Zellenergie. Vitamin C ist der am gründlichsten untersuchte topische Inhaltsstoff für Strahlkraft. Serum O geht weiter und versorgt direkt die Mitochondrien, die Zellen, die Energie produzieren.',

    /* ── Concern 03 · Hydration ── */
    'concerns.c3Num': 'Anliegen 03',
    'concerns.c3Title': 'Dehydration<br><em>& Barriereverlust.</em>',
    'concerns.c3Lede': 'Trockene Haut ist keine Frage von mehr Feuchtigkeitscreme. Es ist eine Frage einer gebrochenen Lipidbarriere. Die meisten Feuchtigkeitscremes enthalten 65–85 % Wasser plus Alkohol und Konservierungsstoffe, was die Haut paradoxerweise noch mehr austrocknet. Serum M baut die Barriere von innen mit hauteigenen Lipiden wieder auf.',

    /* ── Concern 04 · Fine lines ── */
    'concerns.c4Num': 'Anliegen 04',
    'concerns.c4Title': 'Feine Linien<br><em>& Falten.</em>',
    'concerns.c4Lede': 'Oberflächliche Mimikfalten, tiefere Falten durch Zeit und Sonne. Die Zellerneuerung verlangsamt sich mit dem Alter; alte Keratinozyten bleiben länger; die Textur leidet darunter. Retinol kurbelt die Erneuerung an und glättet die Oberfläche; Vitamin C baut die Struktur darunter wieder auf.',

    /* ── Concern 05 · Dark spots ── */
    'concerns.c5Num': 'Anliegen 05',
    'concerns.c5Title': 'Dunkle Flecken<br><em>& Pigmentierung.</em>',
    'concerns.c5Lede': 'Sonnenschäden, hormonelle Veränderungen und postinflammatorische Male konzentrieren Pigment in unebenen Flecken. Vitamin C hemmt das Enzym (Tyrosinase), das die Pigmentproduktion antreibt; Resveratrol neutralisiert die freien Radikale, die sie auslösen.',

    /* ── Concern 06 · Texture ── */
    'concerns.c6Num': 'Anliegen 06',
    'concerns.c6Title': 'Unebene<br><em>Textur.</em>',
    'concerns.c6Lede': 'Raue Stellen, sichtbare Poren, eine unebene Oberfläche, auf der sich Make-up absetzt, statt zu glätten. Das ist fast immer ein Problem der Zellerneuerung: alte, verdickte Hautzellen, die länger bleiben, als sie sollten. Retinol beschleunigt den Zyklus.',

    /* ── Concern 07 · Post-acne ── */
    'concerns.c7Num': 'Anliegen 07',
    'concerns.c7Title': 'Postakne<br><em>& Narben.</em>',
    'concerns.c7Lede': 'Lange nachdem der Schub vorbei ist, ist die Stelle oft noch da. Resveratrol reduziert die postinflammatorische Pigmentierung und unterstützt die Haut, während sie die Reparatur abschließt, die sie begonnen hat. Mit Serum A am Abend kombinieren, für eine Zellerneuerung, die das Verblassen der Male beschleunigt.',

    /* ── Concern 08 · Dullness / mature ── */
    'concerns.c8Num': 'Anliegen 08',
    'concerns.c8Title': 'Fahlheit <em>&amp; nachlassende Elastizität.</em>',
    'concerns.c8Lede': 'Mit zunehmender Reife der Haut verlangsamen sich die Systeme, die ihr Strahlkraft und Spannkraft verleihen. Die Klarheit der Oberfläche lässt nach und die Elastizität wird weicher. Serum O erneuert und revitalisiert reife Haut auf zellulärer Ebene und unterstützt Strahlkraft und Festigkeit, die mit dem Alter nachlassen.',

    /* ── Not sure CTA ── */
    'concerns.unsureLabel': 'Du bist dir noch nicht sicher?',
    'concerns.unsureTitle': 'Wähl nicht. Probier alle fünf.',
    'concerns.unsureBody': 'Das Discovery Kit enthält Reiseformate jedes Serums und einen gedruckten Leitfaden. Das ist der schnellste Weg zu lernen, welches deiner Anliegen welche Formel beantwortet: auf deiner Haut, nicht in der Theorie.',
    'concerns.unsureBtn': 'Discovery Kit holen',

    /* ── Footer (page-specific extra) ── */
    'concerns.ftLearnRonlan': 'Über Dr. Ronlán',

    /* ── Theme-only: Concern 08 alt framing (fatigue / low energy) ── */
    'concerns.c8TitleFatigue': 'Reduzierte Vitalität<br><em>& geringe Energie.</em>',
    'concerns.c8LedeFatigue': 'Eine Haut, der es an Strahlkraft fehlt, hängt nicht immer von dem ab, was an der Oberfläche zu sehen ist. Sie hängt von dem ab, was sie produziert. Die mitochondriale Produktion nimmt mit dem Alter ab, und mit ihr die Fähigkeit der Zelle, Kollagen zu bilden und Schäden zu reparieren. Serum O versorgt das System direkt und gibt den Zellen wieder Energie.',

    /* ── Theme-only: application banner (conditional) ── */
    'concerns.appDividerLabel': 'In der Praxis',
    'concerns.appDividerQuote': 'Zwei Tropfen, morgens und abends. Die Haut, die du hast, gut versorgt.',

    /* ── Theme-only: shortened unsure body (no printed guide) ── */
    'concerns.unsureBodyShort': 'Das Discovery Kit enthält Reiseformate jedes Serums. Das ist der schnellste Weg zu lernen, welches deiner Anliegen welche Formel beantwortet: auf deiner Haut, nicht in der Theorie.'

  });
})();
